import { render } from "./MenuMinimized.vue?vue&type=template&id=63a7ce7e&scoped=true"
import script from "./MenuMinimized.vue?vue&type=script&lang=js"
export * from "./MenuMinimized.vue?vue&type=script&lang=js"

import "./MenuMinimized.vue?vue&type=style&index=0&id=63a7ce7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-63a7ce7e"

export default script